/**
 * AskMayaButton — botão contextual reutilizável.
 *
 * Uso:
 *   <AskMayaButton prompt="Me explique como funciona esta tela de holerites" />
 *   <AskMayaButton prompt="..." variant="text" label="Dúvidas?" />
 */
import React from 'react';
import { Sparkles, HelpCircle } from 'lucide-react';
import { Button } from './ui/button';
import { useMaya } from '../contexts/MayaContext';
import MayaAvatar from './maya/MayaAvatar';

const AskMayaButton = ({
  prompt,
  label = 'Pergunte à Maya',
  variant = 'badge',  // 'badge' | 'text' | 'icon'
  className = '',
  testId,
}) => {
  const { askMaya } = useMaya();

  if (!prompt) return null;

  if (variant === 'icon') {
    return (
      <button
        onClick={() => askMaya(prompt)}
        className={`text-indigo-500 hover:text-indigo-700 transition-colors ${className}`}
        title={label}
        data-testid={testId || 'ask-maya-icon'}
      >
        <HelpCircle className="h-4 w-4" />
      </button>
    );
  }

  if (variant === 'text') {
    return (
      <button
        onClick={() => askMaya(prompt)}
        className={`text-xs text-indigo-600 hover:text-indigo-800 underline decoration-dotted underline-offset-2 inline-flex items-center gap-1 ${className}`}
        data-testid={testId || 'ask-maya-text'}
      >
        <Sparkles className="h-3 w-3" /> {label}
      </button>
    );
  }

  // default: badge
  return (
    <Button
      type="button"
      size="sm"
      variant="outline"
      onClick={() => askMaya(prompt)}
      className={`border-indigo-200 bg-gradient-to-r from-indigo-50 to-purple-50 hover:from-indigo-100 hover:to-purple-100 text-indigo-700 text-xs h-7 px-2 gap-1.5 ${className}`}
      data-testid={testId || 'ask-maya-btn'}
    >
      <MayaAvatar variant="happy" size="xs" /> {label}
    </Button>
  );
};

export default AskMayaButton;
